export type DeelMode = 'IEDEREEN' | 'SPECIFIEK';
